import React, { useCallback, useState } from 'react';
import { Button } from '@mui/material';
import ClaimsService from 'services/api/ClaimsService';
import Modal from 'components/shared/Modal';
import { useSnackbar } from 'notistack';
import { ModalProps } from 'store/types/ComponentProps';
import { Claim } from 'store/types/Claim';
import { defaultSnackbarErrorProps } from 'util/Layout';

import commonStyles from 'styles/common.module.scss';

interface DisputeClaimModalProps extends ModalProps {
  companyId: string;
  data?: Claim;
  onSubmit: () => void;
}

const DisputeClaimModal: React.FunctionComponent<DisputeClaimModalProps> = ({
  companyId,
  data,
  open,
  onClose,
  onSubmit,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);

  const handleSubmit = useCallback(() => {
    if (data) {
      setLoading(true);
      ClaimsService.disputeClaim(companyId, data.id)
        .then(() => {
          enqueueSnackbar('Claim disputed', { variant: 'success' });
          onSubmit();
        })
        .catch((errorMessage) => enqueueSnackbar(errorMessage, defaultSnackbarErrorProps))
        .finally(() => setLoading(false));
    }
  }, [companyId, data, enqueueSnackbar, onSubmit]);

  return (
    <Modal
      title={'Dispute Claim'}
      open={open}
      disableBackdropClick={false}
      maxWidth={'xs'}
      loading={loading}
      onClose={onClose}
      onSubmit={handleSubmit}
      actions={
        <>
          <Button color={'secondary'} variant={'outlined'} onClick={onClose} disabled={loading}>
            {'Cancel'}
          </Button>
          <Button
            type={'submit'}
            variant={'contained'}
            className={commonStyles.dangerButtonContained}
            disabled={loading}
          >
            {'Dispute'}
          </Button>
        </>
      }
    >
      <p className={commonStyles.text}>Are you sure you would like to dispute this claim?</p>
    </Modal>
  );
};
export default DisputeClaimModal;
